import { __assign } from "tslib";
import React from 'react';
export var VerElement = function (p) { return React.createElement(Block, __assign({}, p)); };
var Block = function (_a) {
    var element = _a.element, children = _a.children;
    switch (element.type) {
        case 'heading-one':
            return React.createElement("h1", { style: getCSS(element) }, children);
        case 'heading-two':
            return React.createElement("h2", { style: getCSS(element) }, children);
        case 'heading-tre':
            return React.createElement("h3", { style: getCSS(element) }, children);
        case 'heading-for':
            return React.createElement("h4", { style: getCSS(element) }, children);
        default:
            return React.createElement("p", { style: getCSS(element) }, children);
    }
};
export var VerLeaf = function (_a) {
    var leaf = _a.leaf;
    var color = leaf.color, backgroundColor = leaf.backgroundColor, fontFamily = leaf.fontFamily, fontSize = leaf.fontSize, bold = leaf.bold, italic = leaf.italic, underline = leaf.underline, text = leaf.text;
    var style = {
        color: color,
        fontFamily: fontFamily,
        backgroundColor: backgroundColor,
        fontSize: fontSize ? "".concat(fontSize / 10, "rem") : undefined,
        fontWeight: bold ? 'bold' : 'normal',
        fontStyle: italic ? 'italic' : 'normal',
        textDecoration: underline ? 'underline' : 'none'
    };
    return React.createElement("span", { style: style, dangerouslySetInnerHTML: { __html: text.replaceAll('¤', '"') } });
};
var getCSS = function (_a) {
    var align = _a.align, tabs = _a.tabs, type = _a.type, list = _a.list, children = _a.children;
    var font = getFontSize(type) / 10;
    var t2 = tabs * 2;
    var t = list === 'paragraph' ? t2 : t2 + font;
    var s = list === 'paragraph'
        ? {}
        : {
            display: 'list-item',
            listStyleType: list === 'bulleted-list' ? 'disc' : 'square'
        };
    var color = children[0] ? children[0].color : '#000';
    return __assign(__assign({ float: 'right', textAlign: align, padding: '0 0 0 0', fontSize: "".concat(font, "rem"), minHeight: "".concat(font, "rem"), width: "calc(100% - ".concat(t + 0.1, "rem)"), margin: '.05rem .05rem .05rem .05rem' }, s), { color: color });
};
var getFontSize = function (type) {
    if (type === 'heading-one')
        return 26;
    if (type === 'heading-two')
        return 22;
    if (type === 'heading-tre')
        return 18;
    if (type === 'heading-for')
        return 14;
    return 10;
};
//# sourceMappingURL=Ver.js.map